import BackerLogo1 from './innovate-uk-logo.png'
import BackerLogo2 from './erdf-logo.png'
import BackerLogo3 from './dwp-logo.png'
import BackerLogo4 from './kent-county-council-logo.png'

export const Section5Images = {
  BackerLogo1,
  BackerLogo2,
  BackerLogo3,
  BackerLogo4,
}
